import { Controller } from "@hotwired/stimulus"

// Variant A — REDACT loop: progressively censors each sensitive field with
// animated purple blocks, then reveals a safe value. Pauses when offscreen.
// Respects prefers-reduced-motion (skips the loop entirely if set).
export default class extends Controller {
  static targets = ["fields", "status"]

  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.#fields = Array.from(this.fieldsTarget.querySelectorAll(".field"))
    this.#originals = {}
    this.#fields.forEach((field) => {
      this.#originals[field.dataset.redactKey] = field.querySelector(".field-value").textContent.trim()
    })

    if ("IntersectionObserver" in window) {
      this.#observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.#start()
            } else {
              this.#stop()
            }
          })
        },
        { threshold: 0.2 }
      )
      this.#observer.observe(this.element)
    } else {
      this.#start()
    }
  }

  disconnect() {
    this.#stop()
    if (this.#observer) this.#observer.disconnect()
  }

  // ── private ──────────────────────────────────────────

  #timer = null
  #index = 0
  #fields = []
  #originals = {}
  #observer = null

  #start() {
    if (this.#timer) return
    this.#tick()
  }

  #stop() {
    if (this.#timer) {
      clearTimeout(this.#timer)
      this.#timer = null
    }
  }

  #tick() {
    if (this.#index === 0) this.#reset()

    if (this.#index < this.#fields.length) {
      const field = this.#fields[this.#index]
      const key = field.dataset.redactKey
      const safeValue = field.dataset.redactSafe

      field.classList.add("is-redacting")
      const valueElement = field.querySelector(".field-value")
      valueElement.innerHTML = this.#buildBlocks(this.#originals[key])

      this.#timer = setTimeout(() => {
        field.classList.remove("is-redacting")
        field.classList.add("is-redacted")
        valueElement.innerHTML = `<span class="field-text">${safeValue}</span>`
        this.#index++
        this.#timer = setTimeout(() => this.#tick(), 1100)
      }, 500)
    } else {
      if (this.hasStatusTarget) {
        this.statusTarget.querySelector(".status-text").textContent = "✓ Tudo protegido pela Gimmo"
      }
      this.#index = 0
      this.#timer = setTimeout(() => this.#tick(), 2400)
    }
  }

  #reset() {
    this.#fields.forEach((field) => {
      field.classList.remove("is-redacting", "is-redacted")
      const key = field.dataset.redactKey
      const valueElement = field.querySelector(".field-value")
      valueElement.innerHTML = `<span class="field-text">${this.#originals[key]}</span>`
    })
    if (this.hasStatusTarget) {
      this.statusTarget.querySelector(".status-text").textContent = "Gimmo protegendo…"
    }
  }

  #buildBlocks(text) {
    const length = Math.min(text.length, 18)
    const blocks = []
    let totalWidth = 0
    while (totalWidth < length) {
      const width = 6 + Math.random() * 14
      blocks.push(`<span class="redact-block" style="width:${Math.min(width, length - totalWidth) * 6}px;"></span>`)
      totalWidth += width + 2
    }
    return blocks.join(" ")
  }
}
